export default __webpack_public_path__ + "static/media/34t.a160e2e8.jpg";